import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Option = createReactComponent("Option", ["svg", defaultAttributes, [["path", {
  d: "M3 3h6l6 18h6",
  key: "1gmagw"
}], ["path", {
  d: "M14 3h7",
  key: "1n0z0g"
}]]]);
export default Option;